import { render, staticRenderFns } from "./BsCardHeader.vue?vue&type=template&id=3f220b18&scoped=true&"
import script from "./BsCardHeader.vue?vue&type=script&lang=js&"
export * from "./BsCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f220b18",
  null
  
)

export default component.exports